import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DispatchListingsComponent} from './dispatch-listings/dispatch-listings.component';
import {DispatchMonitoringComponent} from './dispatch-monitoring/dispatch-monitoring.component';
import {DispatchNewComponent} from './dispatch-new/dispatch-new.component';
import {ProgramDispatchesComponent} from './program-dispatches/program-dispatches.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProgramDetailsModule} from '../program-details/program-details.module';
import {CalibrantLoadModule} from '../../shared/calibrant-load/calibrant-load.module';
import {AccountStatusModule} from '../../shared/account-status/account-status.module';
import {MapModule} from '../../shared/map/map.module';
import {SlideToggleModule} from '../../shared/slide-toggle/slide-toggle.module';
import {ProgramDemandProfileModule} from './program-demand-profile/program-demand-profile.module';
import {GaChartModule} from "../../shared/charts/ga-chart/ga-chart.module";
import {RangeSelectorModule} from "../../shared/range-selector/range-selector.module";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {NgxMaterialTimepickerModule} from "ngx-material-timepicker";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatTooltipModule} from "@angular/material/tooltip";
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatButton } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';
import { MatTimepicker, MatTimepickerInput, MatTimepickerToggle } from '@angular/material/timepicker';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FontAwesomeModule,
    FormsModule,
    ProgramDetailsModule,
    CalibrantLoadModule,
    ReactiveFormsModule,
    AccountStatusModule,
    MapModule,
    SlideToggleModule,
    ProgramDemandProfileModule,
    GaChartModule,
    RangeSelectorModule,
    MatDialogModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    // NgxMaterialTimepickerModule,
    MatSortModule,
    MatTableModule,
    MatPaginatorModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatSlideToggle,
    MatButton,
    MatRipple,
    MatTimepickerToggle,
    MatTimepicker,
    MatTimepickerInput,
  ],
    declarations: [
        DispatchListingsComponent,
        DispatchMonitoringComponent,
        DispatchNewComponent,
        ProgramDispatchesComponent,
    ],
    exports: [
        DispatchListingsComponent,
        DispatchMonitoringComponent,
        DispatchNewComponent,
        ProgramDispatchesComponent
    ]
})
export class DispatchModule { }
